import { ModelFactory } from '../$models'
import { ColumnDefByColName } from '../$models/ModelDef'
import { VirtualModelFactory } from '../$virtualModels'
import { cleanupDataForSave } from './cleanupDataForSave'

const columnsThatShouldBeNullifiedIfTheValueIsEmptyString = [
  'NUMBER',
  'DECIMAL',
  'FLOAT',
  'DOUBLE',
  'BIGINTEGER',
  'DATETIME',
  'ITME',
  'DATEONLY',
  'RELATIONSHIP_MANY_TO_ONE',
]

export class TransformDataBeforeSave {
  data: { [key: string]: any }
  columns: ColumnDefByColName
  model: ModelFactory | null
  virtualModel: VirtualModelFactory | null
  virtualModelColumns: ColumnDefByColName

  constructor(data, model: ModelFactory, virtualModel: VirtualModelFactory) {
    this.data = data
    this.model = model
    this.columns = model?.columns || {}
    this.virtualModel = virtualModel || null
    this.virtualModelColumns = virtualModel?.columnsMergedWithBaseModel || {}
  }

  run(): any {
    Object.keys(this.data || {}).map((key) => {
      const columnType = this.virtualModelColumns[key]?.type || this.columns[key]?.type
      // M2O Relationship で Object として Nested 保存しようとしている場合には、再帰的に変換する
      if (
        columnType === 'RELATIONSHIP_MANY_TO_ONE' &&
        typeof this.data[key] === 'object'
      ) {
        const relationTargetModelName =
          this.virtualModelColumns[key]?.relationshipManyToOne?.collectionName ||
          this.columns[key]?.relationshipManyToOne?.collectionName
        const relationTargetVirtualModelName =
          this.virtualModelColumns[key]?.relationshipManyToOne?.virtualModelName ||
          this.columns[key]?.relationshipManyToOne?.virtualModelName
        this.data[key] = new TransformDataBeforeSave(
          this.data[key],
          $core.$models[relationTargetModelName],
          $core.$virtualModels[relationTargetVirtualModelName] || null,
        ).run()
      }
      // O2M Relationship で Object として Nested 保存しようとしている場合には、再帰的に変換する
      if (
        (columnType === 'RELATIONSHIP_ONE_TO_MANY' || columnType === 'ARRAY_OF_OBJECT') &&
        typeof this.data[key] === 'object' &&
        Array.isArray(this.data[key]) &&
        this.data[key]?.length > 0
      ) {
        this.data[key] = this.data[key].map((d) => {
          if (typeof d === 'object') {
            const relationTargetModelName =
              this.virtualModelColumns[key]?.relationshipOneToMany?.collectionName ||
              this.columns[key]?.relationshipOneToMany?.collectionName
            const relationTargetVirtualModelName =
              this.virtualModelColumns[key]?.relationshipOneToMany?.virtualModelName ||
              this.columns[key]?.relationshipOneToMany?.virtualModelName
            return new TransformDataBeforeSave(
              d,
              $core.$models[relationTargetModelName],
              $core.$virtualModels[relationTargetVirtualModelName] || null,
            ).run()
          }
          return d
        })
      }
      if (this.data[key] === '') {
        if (columnsThatShouldBeNullifiedIfTheValueIsEmptyString.includes(columnType)) {
          this.data[key] = null
        }
      }
      // Unique 制約がかかっていて、値がfalsyならnullでないと保存できない (unique空文字禁止)
      if (this.columns[key]?.unique === true && !this.data[key]) {
        this.data[key] = null
      }
      if (columnType === 'BOOLEAN') {
        if (
          this.data[key] == 0 ||
          this.data[key] == '0' ||
          this.data[key] === 'false' ||
          this.data[key] === 'FALSE'
        ) {
          this.data[key] = false
        } else {
          this.data[key] = !!this.data[key]
        }
      }
    })
    return cleanupDataForSave(this.data, this.model)
  }
}
